import React from "react";
import PropTypes from "prop-types";
import LoaderIcon from "Components/loader/LoaderIcon";
import TranslatedString from "Components/TranslatedString";
import { Icon, docs } from "Icons/index";
import docsLinks from "../../docs.js";
import cx from "classnames";
import s from "./button.scss";
import { isVianovaCustomer } from "Utils/vianova";

const DefaultProps = {
  loading: false,
  disabled: false,
  color: "accent",
  className: "",
  type: "submit",
};

const ContextTypes = {
  getLoggedUser: PropTypes.func,
};

class Button extends React.Component {
  openDocs() {
    const lang = this.context.getLoggedUser().language;
    const url = docsLinks[lang][this.props.docsKey];
    window.open(url, "_blank");
  }

  focus = () => this.btn.focus();

  render() {
    const {
      className,
      icon,
      onlyIcon,
      color,
      sizeSmall,
      loading,
      type,
      disabled,
      children,
      onClick,
      id,
      style,
      docsKey,
    } = this.props;

    const user = this.context.getLoggedUser();

    const isVianovaPostmaster = isVianovaCustomer(user?.code) && ["Postmaster", "Manager"].includes(user?.type);

    if (color === "docs" && !["Admin", "Customer", "TeamMember"].includes(user?.type) && !isVianovaPostmaster) {
      /* no button to render */
      return <div></div>;
    }

    return (
      <button
        onClick={docsKey ? this.openDocs.bind(this) : onClick}
        disabled={disabled}
        className={cx(
          className,
          s.btn,
          {
            [s.hide]: docsKey && IS_APP,
            [s[color]]: color !== "accentv",
            [s.onlyIcon]: onlyIcon,
            [s.withIcon]: icon,
            [s.sizeSmall]: sizeSmall,
            "bg-[--accent-v] hover:bg-red-600": color === "accentv" && !loading,
            [s.disabled]: disabled || loading,
          },
          "relative"
        )}
        id={id}
        type={type}
        style={style}
        ref={(btn) => (this.btn = btn)}
      >
        {(icon || color === "docs") && (
          <Icon
            className={cx(s.icon, loading ? "invisible" : "")}
            svg={color === "docs" ? docs : icon}
            width="0.875rem"
            height="0.875rem"
          />
        )}

        {!onlyIcon && (
          <div className={cx(s.label, loading ? "invisible" : "")}>
            <TranslatedString>{children}</TranslatedString>
          </div>
        )}

        {loading && <LoaderIcon className="absolute" iconSize="0.875rem" color="var(--text-a40)" />}
      </button>
    );
  }
}

Button.defaultProps = DefaultProps;
Button.contextTypes = ContextTypes;

export default Button;
